import React from 'react';
import { FaInstagram, FaGlobe } from "react-icons/fa";

const Footer = () => {
  const handleWriteToUs = () => {
    window.location.href = 'mailto:brunchclubhospitality@gmail.com';
  };

  return (
    <footer className="bg-espresso text-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* About Section */}
          <div className="lg:col-span-2">
            <h2 className="font-playfair text-3xl md:text-4xl font-bold mb-4 text-burnt-amber">
              THE BRUNCH CLUB
            </h2>
            <p className="font-nunito text-warm-taupe text-sm leading-relaxed mb-6">
              At The Brunch Club, we're redefining Indian hospitality. We create 
              memorable dining experiences through our diverse portfolio of restaurants, 
              each offering a unique culinary journey. From traditional flavors to 
              modern interpretations, we celebrate the richness of food, culture, 
              and community.
            </p>
            <button
              onClick={handleWriteToUs}
              className="bg-burnt-amber hover:bg-burnt-amber/90 text-cream font-poppins font-semibold py-3 px-8 rounded-full transition-all duration-300 transform hover:scale-105 uppercase tracking-wide text-sm"
            >
              Write to Us
            </button>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-playfair text-xl font-semibold mb-4 text-dull-gold">
              Get In Touch
            </h3>
            <div className="space-y-3 font-nunito text-warm-taupe text-sm">
              <div>
                <p className="font-semibold text-cream mb-1">Email</p>
                <a 
                  href="mailto:brunchclubhospitality@gmail.com"
                  className="hover:text-burnt-amber transition-colors"
                >
                  brunchclubhospitality@gmail.com
                </a>
              </div>
              <div>
                <p className="font-semibold text-cream mb-1">Phone</p>
                <a 
                  href="tel:+917753851777"
                  className="hover:text-burnt-amber transition-colors"
                >
                  +91 7753851777
                </a>
              </div>
              <div>
                <p className="font-semibold text-cream mb-1">Instagram</p>
                <a 
                  href="https://instagram.com/brunchclubhospitality"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-burnt-amber transition-colors"
                >
                  @brunchclubhospitality
                </a>
              </div>
            </div>
          </div>

          {/* Our Restaurants */}
          <div>
            <h3 className="font-playfair text-xl font-semibold mb-4 text-dull-gold">
              Our Restaurants
            </h3>

            <div className="space-y-4">
              
              {/* FOSHO */}
              <div>
                <h4 className="font-poppins font-semibold text-cream mb-2">FOSHO</h4>
                <div className="space-y-1 text-sm font-nunito text-warm-taupe">
                  
                  <a 
                    href="https://www.foshoindia.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 hover:text-burnt-amber transition-colors"
                  >
                    <FaGlobe className="text-base" />
                    foshoindia.com
                  </a>

                  <a 
                    href="https://instagram.com/foshoindia"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 hover:text-burnt-amber transition-colors"
                  >
                    <FaInstagram className="text-base" />
                    @foshoindia
                  </a>

                </div>
              </div>

              {/* Cafe HONS */}
              <div>
                <h4 className="font-poppins font-semibold text-cream mb-2">Cafe HONS</h4>
                <div className="space-y-1 text-sm font-nunito text-warm-taupe">
                  
                  <a 
                    href="https://www.cafehons.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 hover:text-burnt-amber transition-colors"
                  >
                    <FaGlobe className="text-base" />
                    cafehons.com
                  </a>

                  <a 
                    href="https://instagram.com/cafehons"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 hover:text-burnt-amber transition-colors"
                  >
                    <FaInstagram className="text-base" />
                    @cafehons
                  </a>

                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-warm-taupe/20">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="font-nunito text-warm-taupe text-sm text-center md:text-left">
              © {new Date().getFullYear()} The Brunch Club. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <a
                href="https://instagram.com/brunchclubhospitality"
                target="_blank"
                rel="noopener noreferrer"
                className="text-warm-taupe hover:text-burnt-amber transition-colors"
                aria-label="Instagram"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

